module.exports = __webpack_public_path__ + "img/5.d56dae75.png";